/** @jsxImportSource @emotion/react */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { formatCurrency } from '@quickbit/backoffice-core-frontend';
import {
  Icon,
  iconMap,
  IconName,
  List,
  ListItem,
  useTheme,
} from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsync } from 'react-use';
import { QBLoader } from 'components';
import { Transaction, TransactionItem } from 'components/Transactions';
import {
  getTransactionDetails,
  searchTransactions,
} from 'tabs/NewSkinning/SkinningUsers/api';

interface Props {
  userId: string;
}
export const Transactions = ({ userId }: Props) => {
  const { palette, spacing, shape } = useTheme();
  const [selectedTxId, setSelectedTxId] = useState<string>();
  const [offsetTop, setOffsetTop] = useState<number>();

  const { value } = useAsync(() => {
    return searchTransactions({ filters: { userId } });
  }, [userId]);

  const { value: details, loading: detailsLoading } = useAsync(async () => {
    if (!selectedTxId) return null;
    return getTransactionDetails(selectedTxId);
  }, [selectedTxId]);

  return (
    <div>
      <div
        css={[
          { display: 'grid', gap: spacing.xxs, position: 'relative' },
          selectedTxId && { gridTemplateColumns: '1fr 1fr' },
        ]}
      >
        <List>
          {value &&
            value.map((transaction) => (
              <ListItem
                key={transaction.previewId}
                icon={
                  transaction.amount.currencyCode in iconMap
                    ? (transaction.amount.currencyCode as IconName)
                    : undefined
                }
                title={new Date(transaction.createdAt).toLocaleString()}
                subtitle={transaction.destinationAddress}
                content={formatCurrency(transaction.amount)}
                subcontent={formatCurrency(transaction.euroAmount)}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedTxId(transaction.previewId);
                  setOffsetTop(
                    selectedTxId === transaction.previewId
                      ? undefined
                      : e.currentTarget.offsetTop
                  );
                }}
                action={
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedTxId(
                        selectedTxId === transaction.previewId
                          ? undefined
                          : transaction.previewId
                      );
                    }}
                    css={{
                      svg: {
                        transform:
                          selectedTxId !== transaction.previewId
                            ? 'rotate(180deg)'
                            : '',
                        stroke: palette.grey.default,
                        fill: 'none',
                      },
                    }}
                  >
                    <Icon name="chevron" />
                  </div>
                }
              />
            ))}
        </List>
        {selectedTxId && (
          <div
            css={{
              background: palette.white,
              padding: spacing.xxs,
              border: `1px solid ${palette.grey.x100}`,
              borderRadius: shape.borderRadius,
              display: 'flex',
              flexDirection: 'column',
              gap: spacing.xxs,
              position: 'absolute',
              width: '49%',
              right: 0,
              top: offsetTop ? offsetTop : 0,
            }}
          >
            {detailsLoading && <QBLoader />}
            {details && selectedTxId === details.previewId && (
              <>
                {Object.entries(details).map(([k, v]) => (
                  <TransactionItem
                    key={k}
                    name={k as keyof Transaction}
                    value={v}
                  />
                ))}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
